import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { UIActions } from 'common/constants/actions';

const PageTitle = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch({
      type: UIActions.SET_PAGE_TITLE,
      payload: location.pathname,
    });
  }, [dispatch, location]);

  return null;
};

export default PageTitle;

export const Container = styled.div`
  padding: 30px;
`;

export const SectionDiv = styled.div`
  padding-bottom: 35px;
`;
